import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { getGameType } from '../../../variables/gameTypes';

const RESULT_CAP = 40;

// No existing reusable value-picker for Grid (unlike Conversation) - this is
// a new component modeled directly on ConversationTemplatePicker.jsx's
// structure (search input, card-grid dropdown), hitting /api/grid instead.
function GridSearchSelect({ value, onChange, placeholder }) {
   const [games, setGames] = useState([]);
   const [loading, setLoading] = useState(false);
   const [query, setQuery] = useState('');
   const [open, setOpen] = useState(false);
   const wrapRef = useRef(null);

   useEffect(() => {
      if(!open || games.length > 0 || loading) return;
      setLoading(true);
      axios.get('/api/grid', { withCredentials: true })
         .then(response => setGames(Array.isArray(response.data) ? response.data : []))
         .catch(() => setGames([]))
         .finally(() => setLoading(false));
   }, [open, games.length, loading]);

   useEffect(() => {
      if(!value) setQuery('');
   }, [value]);

   useEffect(() => {
      const handleOutside = (e) => { if(wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
      document.addEventListener('mousedown', handleOutside);
      return () => document.removeEventListener('mousedown', handleOutside);
   }, []);

   const selected = games.find(g => String(g.id) === String(value));
   const filtered = games.filter(g => !query.trim() || (g.name || '').toLowerCase().includes(query.trim().toLowerCase())).slice(0, RESULT_CAP);
   const displayLabel = (g) => g.name + ' · ' + getGameType(g.type).label;

   const handlePick = (g) => { onChange(String(g.id)); setQuery(displayLabel(g)); setOpen(false); };
   const handleInputChange = (e) => { setQuery(e.target.value); if(value) onChange(''); };
   const displayValue = open ? query : (selected ? displayLabel(selected) : query);

   return (
      <div className='conv-template-picker' ref={wrapRef}>
         <input className='submit-field from-input txt-c conv-template-picker-input' type='text' placeholder={placeholder}
            value={displayValue} onFocus={() => { setOpen(true); setQuery(''); }} onChange={handleInputChange} />
         {open ? (
            <div className='conv-template-picker-dropdown'>
               <div className='conv-template-picker-grid'>
                  {loading ? <div className='conv-template-picker-empty'>Завантаження...</div> : ''}
                  {!loading && filtered.length === 0 ? <div className='conv-template-picker-empty'>Нічого не знайдено</div> : ''}
                  {!loading ? filtered.map(g => (
                     <div key={g.id} className='conv-template-plate' onClick={() => handlePick(g)}>
                        <div className='conv-template-plate-top'>
                           <span className='conv-template-plate-name'>{g.name}</span>
                           <span className='conv-template-plate-level' style={{ borderColor: getGameType(g.type).accent, color: getGameType(g.type).accent }}>{getGameType(g.type).label}</span>
                        </div>
                     </div>
                  )) : ''}
               </div>
            </div>
         ) : ''}
      </div>
   );
}

export default function EmbedGridPicker({ block, onSave, onCancel }) {
   const [gridId, setGridId] = useState(block.grid ? String(block.grid.id) : '');

   const handleSave = () => onSave({ grid: gridId });

   return (
      <div className='exercise-block-embed-editor'>
         <GridSearchSelect value={gridId} onChange={setGridId} placeholder='Обрати існуючу гру...' />
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderEmbedGridPreview(block) {
   if(!block.grid) return <span className='exercise-block-empty-hint'>Гру не обрано</span>;
   return <div className='exercise-block-embed-preview'>🎮 {block.grid.name}</div>;
}
